export default [
  { key: 'createPermission', label: 'Create' },
  { key: 'readPermission', label: 'Read' },
  { key: 'readOwnPermission', label: 'Read Own' },
  { key: 'updatePermission', label: 'Update' },
  { key: 'updateOwnPermission', label: 'Update Own' },
  { key: 'deletePermission', label: 'Delete' },
  { key: 'deleteOwnPermission', label: 'Delete Own' },
]
